<template>
  <div>
    <el-form :model="data.lastNode" ref="pstRef" status-icon label-width="80px">
      <el-form-item label="办理方式">
        <el-radio-group v-model="data.form.selectType">
          <el-radio :label="4">审核通过</el-radio>
          <el-radio :label="2">重新答复</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="回复留言">
        <el-input
          type="textarea"
          :rows="3"
          v-model="data.form.message"
          :disabled="data.form.selectType == 4 || data.lastNode.isSucces"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
  
<script>
export default {
  name: "GDanReplyAudit",
  props: ["pstId"],
  created() {
    this.data.pst.id = this.pstId;
    this.data.user = this.pstApi.getUserData();
    if (this.data.pst.id) {
      //读取留言信息
      this.getPst();
    }
  },
  data() {
    return {
      tabPosition: "right",
      tabIndex: 0,
      activeTabName: "tabLast",
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
        },
        nodes: [],
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 0,
          status: 4,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
        },
        replyNode: "",
        form: {
          selectType: 4,
          message: "",
        },
      },
    };
  },
  methods: {
    //读取舆情信息
    getPst() {
      let pstId = this.data.pst.id;
      this.pstApi
        .getPstInfo(pstId)
        .then((res) => {
          var data = res.data;
          this.data.pst = data;
          var lastNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          if (lastNodes.length > 0) {
            this.data.lastNode = lastNodes[0];
          }

          this.data.form.selectType = this.data.lastNode.status;
          this.data.form.message = this.data.lastNode.nodeMessage;
          //
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;
          //
          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );
          var replyNodes = data.nodeInfos.filter((node) => node.status == 2);
          if (replyNodes.length > 0) {
            this.data.replyNode = replyNodes[0];
          }
          //
          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
        })
        .catch((err) => {
          this.$toast(err.response.data.message);
        });
    },
    formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let message = this.data.form.message;
      let selectType = this.data.form.selectType;
      var submitType = 0;
      if (selectType == 2) {
        submitType = -1;
      } else if (selectType == 4 && buttonType == 1) {
        submitType = 1;
      }
      if (message == "" && selectType == 2) {
        this.$toast("请填写提交信息");
        return;
      }
      if (selectType == 4) {
        message = "审核通过";
      }

      this.pstApi
        .replyPstAudit(pstId, message, submitType)
        .then((res) => {
          if (submitType) {
            this.$toast("提交成功");
            //success
            this.$emit("success");
          } else {
            this.$toast("保存成功");
            this.getPst();
          }
        })
        .catch((err) => {
          this.$toast(err.response.data.message);
        });
    },
  },
};
</script>
  
<style lang="less" scoped>
/deep/.el-radio {
  margin-right: 5px;
}
/deep/.el-select-dropdown {
  // position: absolute;
  z-index: 99999;
}
</style>